module.exports = __webpack_public_path__ + "img/fx_pro_iOS.f562d41e.png";